import { render, staticRenderFns } from "./card-files.vue?vue&type=template&id=06caea73&scoped=true"
import script from "./card-files.vue?vue&type=script&lang=js"
export * from "./card-files.vue?vue&type=script&lang=js"
import style0 from "./card-files.vue?vue&type=style&index=0&id=06caea73&prod&lang=css"
import style1 from "./card-files.vue?vue&type=style&index=1&id=06caea73&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06caea73",
  null
  
)

export default component.exports